import React from 'react';

interface AudioViewerProps {
  url: string;
}

const AudioViewer: React.FC<AudioViewerProps> = ({ url }) => {
  return (
    <div style={{ 
      width: '100vw', 
      height: '100vh', 
      position: 'fixed',
      top: 0,
      left: 0,
      backgroundColor: '#f8f9fa',
      display: 'flex',
      alignItems: 'center',
      justifyContent: 'center',
      flexDirection: 'column'
    }}>
      <div style={{
        backgroundColor: '#ffffff',
        padding: '40px',
        borderRadius: '12px',
        boxShadow: '0 4px 20px rgba(0, 0, 0, 0.1)',
        textAlign: 'center',
        maxWidth: '500px',
        width: '90%'
      }}>
        <h2 style={{ 
          color: '#333', 
          marginBottom: '30px',
          fontSize: '24px',
          fontWeight: '600'
        }}>
          오디오 플레이어
        </h2>
        <audio
          src={url}
          controls
          style={{
            width: '100%',
            marginBottom: '20px'
          }}
        >
          브라우저가 오디오를 지원하지 않습니다.
        </audio>
        <p style={{ 
          color: '#666', 
          fontSize: '14px',
          margin: 0
        }}>
          오디오 파일을 재생하려면 위의 컨트롤을 사용하세요.
        </p>
      </div>
    </div>
  );
};

export default AudioViewer;
